import { render, staticRenderFns } from "./FairBattles.vue?vue&type=template&id=7a465718&scoped=true"
import script from "./FairBattles.vue?vue&type=script&lang=js"
export * from "./FairBattles.vue?vue&type=script&lang=js"
import style0 from "./FairBattles.vue?vue&type=style&index=0&id=7a465718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a465718",
  null
  
)

export default component.exports